var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',_vm._b({ref:"cascaderRef",attrs:{"props":_vm.props,"options":_vm.options,"filter-method":_vm.filterMethod,"size":"small","collapse-tags":"","filterable":"","clearable":""},on:{"change":_vm.selectedChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},'el-cascader',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }